import { render, staticRenderFns } from "./DsFormContent.vue?vue&type=template&id=31941040&scoped=true&"
import script from "./DsFormContent.vue?vue&type=script&lang=js&"
export * from "./DsFormContent.vue?vue&type=script&lang=js&"
import style0 from "./DsFormContent.vue?vue&type=style&index=0&id=31941040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31941040",
  null
  
)

export default component.exports